// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 1024px)";
var _4 = "services-3dHUa";
var _5 = "services_horizontal-3BlXL";
export { _1 as "__esModule", _2 as "mobile", _3 as "tablet", _4 as "services", _5 as "services_horizontal" }
export default { "__esModule": _1, "mobile": _2, "tablet": _3, "services": _4, "services_horizontal": _5 }
